<div *ngIf="checkViewMode('edit') && !isDemoMode && !hasMobileError; else textView" #faceReconHost></div>

<div *ngIf="checkViewMode('edit') && isDemoMode" class="demo-selfie-container">
    <div class="demo-selfie-frame">
        <svg class="demo-avatar" viewBox="0 0 200 200" xmlns="http://www.w3.org/2000/svg">
            <circle cx="100" cy="100" r="100" fill="#e0e0e0"/>
            <circle cx="100" cy="80" r="30" fill="#bdbdbd"/>
            <path d="M 50 180 Q 50 140 100 140 Q 150 140 150 180" fill="#bdbdbd"/>
        </svg>
    </div>
    <div class="demo-camera-indicator" *ngIf="showCapturingMessage">
        <div class="camera-light"></div>
        <span class="camera-text">Capturando selfie...</span>
    </div>
</div>

<ng-template #textView>
    <p *ngIf="!isDemoMode">{{message}}</p>

    <div *ngIf="hasMobileError && !isDemoMode" class="facerecon-btn">
        <button class="btn btn-primary"
            (click)="sendSMS()">
            Receber SMS
        </button>
    </div>
    
    <div *ngIf="hasMobileError && !isDemoMode" class="facerecon-btn">
        <button class="btn btn-primary"
            (click)="sendWhatsapp()">
            Receber Whatsapp
        </button>
    </div>
</ng-template>